import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

import notificationSettingsAuthority from '../../core/notificationSettings/notificationSettingsAuthority';

import accountSettingsModule from './accountSettingsModule';

import '../../../css/accountSettings/accountSettings.scss';

window.Roblox.NotificationSettingsAuthority = notificationSettingsAuthority;

// import all other js files for avatarModule
importFilesUnderPath(require.context('./constants/', true, /\.js$/));
importFilesUnderPath(require.context('./controllers/', true, /\.js$/));
importFilesUnderPath(require.context('./directives/', true, /\.js$/));
importFilesUnderPath(require.context('./services/', true, /\.js$/));

const templateContext = require.context('./', true, /\.html$/);
const templates = templateCacheGenerator(angular, 'accountSettingsTemplates', templateContext);

// self manual initialization
angular.element(() => {
  angular.bootstrap('#user-account', [accountSettingsModule.name, templates.name]);
});

export default accountSettingsModule;
